import React from "react";
import { Box, Typography } from "@mui/material";

const TaskProperty = ({property, value, sx, firstBoxMargin}) => {
  return (
    <Box sx={{
      width: '100%',
      marginTop: sx?.marginTop || '0px',
      pb: sx?.pb || '16px',
      display: 'flex',
      alignContent: 'center',
      flexDirection: sx?.flexDirection || 'row',
      paddingLeft: sx?.paddingLeft || 'inherit',
    }}>
      <Typography sx={{ fontSize: '20px', color: 'background.black', fontWeight: 700, marginLeft: firstBoxMargin || '20px', marginRight: '10px' }}>
        {property}:
      </Typography>
      <Typography sx={{ fontSize: '16px', color: 'background.grey', fontWeight: 400, fontFamily: 'New Transport', marginTop: '2px' }}>
        {value}
      </Typography>
    </Box>
  );
}

export default TaskProperty;
